module.exports = __webpack_public_path__ + "static/media/partner4.a40073d1.png";